export default {
  selectable: true,
};
